module.exports = {
  content: [
    "./index.html",
    "./src/**/*.{vue,js,ts,jsx,tsx}",
  ],
  theme: {
    screens: {
      'xsm': '475px',
      'sm': '640px',
      'md': '768px',
      'lg': '1024px',
      'xl': '1280px',
      '2xl': '1536px',
      '1080p': '1919px'
    },
    fontFamily: {
      'sans': ['Karla', 'sans-serif'],
      'serif': ['Crimson Pro', 'serif'],
    },
    colors: {
      'white': 'rgb(256, 256, 256)',
      'black': 'rgb(62, 56, 56)',
      'offwhite': 'rgb(254, 251, 244)',
      'gray': '#c0bcb7',
      'warm-gray': 'rgb(234, 230, 218)',
      'red': '#d26750',
      'purple': '#8e64d2',
      'green': '#5bc987',


      'moss': '#b1b99a',
      'orange': '#ee6f32',
      'salmon': '#f6ae83',

      'pink': '#e79281',
      'violet': '#a0839f',
      'slate': '#b2bfcd',
      'carbon': '#575656',
      'light-green': '#e3ebcd',

      'map_high': '#1b515a',
      'map_mid': '#9caf8c',
      'map_low': '#ecebb6',

    },
    extend: {
      width: { 'text-block': '768px', }
    },
  },
  plugins: [],
}